import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import is from 'is_js';
import { ToastContainer } from 'react-bootstrap';
import { CloseButton } from 'componentes/common/Toast.js';
import { useAppContext } from 'context/AppProvider.js';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from 'context/AuthProvider';

const App = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition }
  } = useAppContext();

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition]);

  return (
    <>
      <AuthProvider>
        <Outlet />
        <ToastContainer
          closeButton={CloseButton}
          icon={false}
          position="top-end"
        />
      </AuthProvider>
    </>
  );
};

export default App;
